<template>
  <Overlay class="design-change-dialog" v-on="$listeners">
    <div class="design-change-dialog_holder">
      <div class="design-change-dialog_content">
        <h1 class="heading1">{{ $t('Изменить виртуальную обложку') }}</h1>

        <div v-if="designsByPartner" class="design-list">
          <template v-for="(designs, game) in designsByPartner">
            <div v-for="design in designs" :key="design" class="design-list_item"
              @click="selectedDesign = design">
              <CardPicture
                hovering
                :design="design"
                :game="game"
                :selected="selectedDesign === design"
              />
            </div>
          </template>
        </div>

        <Button class="design-change-dialog_button" variant="outlined" @click="close">
          {{ $t('Отменить') }}
        </Button>
        <Button variant="contained" :waiting="loading" :disabled="selectedDesign === initialDesign"
          @click="onChangeCardDesign">
          {{ $t('Да, изменить') }}
        </Button>
        <button class="design-change-dialog_close" @click="close">{{ $t('Close') }}</button>
        <div class="design-change-dialog_error-wrapper">
          <div
            v-bind:class="['design-change-dialog_error', { 'design-change-dialog_error__hidden': !this.changeDesignError }]">
            {{ $t('Возникла ошибка. Повторите попытку.') }}</div>
        </div>
      </div>
    </div>
  </Overlay>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { namespace, State } from 'vuex-class'
import Button from '@/common/components/Button'
import Overlay from '@/common/components/Overlay'
import CardPicture from '@/components/Card/CardPicture.vue'
import { ValidationError } from '@/common/api/errors'

const cards = namespace('cards')

const checkValidationError = error => {
  const properInstance = error instanceof ValidationError
  const [{ code }] = error.errors
  return properInstance && code
}

@Component({
  components: { Overlay, Button, CardPicture }
})
class DesignChangeDialog extends Vue {
  @Prop(({ type: Object, required: true })) card
  @State('designs') designs
  @cards.Action changeCardDesign
  @cards.State loading

  selectedDesign = ''
  initialDesign = ''
  changeDesignError = ''
  fetchDesignsError = ''

  get designsByPartner () {
    return this.designs[this.card.partner]
  }

  created () {
    this.initialDesign = this.card.currentDesign
    this.selectedDesign = this.initialDesign
  }

  async onChangeCardDesign () {
    try {
      await this.changeCardDesign({ design: this.selectedDesign, cardCode: this.card.cardCode })
      this.changeDesignError = ''
      this.close()
    } catch (error) {
      const validationError = checkValidationError(error)

      if (validationError) {
        this.changeDesignError = validationError
      } else {
        this.changeDesignError = ''
        throw error
      }
    }
  }

  close () {
    this.loading || this.$emit('close')
  }
}

export default DesignChangeDialog
</script>

<style lang="scss" src="./styles/design-change-dialog.scss" />
<style lang="scss" src="./styles/design-list.scss" />
